import React, { Component } from "react";
import { connect } from "react-redux";
import { authSelectors } from "../../store/auth";
import { schoolSelectors, schoolActions } from "../../store/school";
import { layoutSelectors } from "../../store/layout";
import { withRouter } from "react-router-dom";
import Header from "./Header";
import { withFirebase } from "../Firebase";
// import {calendarActions} from "../../store/calendar";

const NO_HEADER = ["/app", "/app/pw-forget"];
class HeaderContainer extends Component {
  state = {
    school: null,
  };

  render() {
    const { header, ...rest } = this.props;
    const { location } = this.props;
    return (
      <>
        {!NO_HEADER.includes(location.pathname) && rest.profile && (
          <Header {...header} {...rest} />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: schoolSelectors.isLoading(state.school),
    school: schoolSelectors.refreshSchool(state.school),
    header: layoutSelectors.refreshHeaderProps(state.layout),
    profile: authSelectors.refreshProfile(state.auth),
    isFaculty: authSelectors.isFaculty(state.auth),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateSchool: (data) => dispatch(schoolActions.updateSchoolInfo(data)),
  };
}

export default withFirebase(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(HeaderContainer)
  )
);
